import { render, staticRenderFns } from "./stat-cards.vue?vue&type=template&id=5139ce52&scoped=true&"
import script from "./stat-cards.vue?vue&type=script&lang=js&"
export * from "./stat-cards.vue?vue&type=script&lang=js&"
import style0 from "./stat-cards.vue?vue&type=style&index=0&id=5139ce52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5139ce52",
  null
  
)

export default component.exports